import { isEmpty } from "lodash";

const buildValidParams = (params, defaultParams) => {
	const updated = { ...defaultParams };

	for (const [key, value] of Object.entries(params)) {
		if (value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0)) {
			delete updated[key];
		}
		if (value && !(Array.isArray(value) && value.length === 0)) {
			updated[key] = key === "lastLog.startDate" && typeof value === "string" ? `${value},` : value;
		}
	}

	return isEmpty(updated) ? defaultParams : updated;
};

export default buildValidParams;
